<template>
    <div id="super-user-dashboard">
        <div class="ibox">
            <div class="ibox-body">
                <div class="row">
                    <div class="col-md-2">
                        <div class="form-group">
                            <div class="input-group-icon right">
                                <div class="input-icon"><i class="fa fa-search"></i>
                                </div>

                                <input v-model="projectsFilter" @keyup="filterProjects"
                                       class="form-control" type="text"
                                       :placeholder="$t('message.filterProjects')">
                            </div>
                        </div>
                        <div class="list-project-wrapper">
                            <table class="table table-stripped" style="width: 170px">
                                <tbody style="font-size: 0.9em">
                                <tr @click="projectConsolidation(project)" style="cursor: pointer;"
                                    v-for="(project, index) in projectsFiltered" :key="index">
                                    <td :class="{activeProject: currentProjectIndex === index}" @click="setCurrentIndex(index)">{{project.name}}</td>
                                    <td ><span v-if="project.status">{{$t('message.active')}} <button
                                            style="height: 12px; width: 12px"
                                            class="btn btn-sm btn-success btn-circle activity-button"></button></span><span
                                            v-if="!project.status">{{$t('message.notActive')}} <button
                                            style="height: 12px; width: 12px"
                                            class="btn btn-sm btn-danger btn-circle activity-button"></button></span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div class="col-md-10 text-center tableScroll" :key="currentProject.id" v-if="Object.keys(currentProject).length !== 0 && Object.keys(consolidationData).length !== 0">
                        <consolidation
                                       :stackedOptions="stackedOptions"
                                       :stackedChartDataCollection="stackedChartDataCollection"
                                       :chartOptions="chartOptions"
                                       :horizontalBarDataCollection="horizontalBarDataCollection"
                                       :barDataCollection="barDataCollection"
                                       :consolidation-data="consolidationData"
                                       :currentProject="currentProject"
                                       :mixedChartOptions="mixedChartOptions"
                                       :mixedChartData="mixedChartDataCollection"
                                       ref="cons"
                                       @refreshConsolidation="refreshConsolidation"
                                       ></consolidation>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import Consolidation from './projects/Consolidation'
  import OkModal from '../../modals/OkModal'

  export default {
    components: {
      Consolidation
    },
    props: ['projectId'],
    name: 'SuperUserDashboard',
    data () {
      return {
        projects: [],
        propsArray: [],
        projectsFiltered: [],
        projectsFilter: '',
        consolidationData: {},
        currentProject: {},
        currentProjectIndex: -1,
        horizontalBarDataCollection: null,
        barDataCollection: null,
        mixedChartDataCollection: {},
        stackedChartDataCollection: null,
        stackedOptions:{
                    tooltips: {
                      callbacks: {
                        label: (tooltipItem, data) => {
                          return this.formatToolTipsHorizontalBars(tooltipItem, data)
                        }
                      }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                    xAxes: [{
                        stacked: true
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                    }
        },
        mixedChartOptions: {
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                        return this.formatToolTipsHorizontalBars(tooltipItem, data)
                    }
                  }
                },
                responsive: true,
                  maintainAspectRatio: false,
                  elements: {
                          line: {
                              tension: 0
                          }
                      },
                  scales: {
                      yAxes: [{
                      ticks: {
                          beginAtZero: true,
                          padding: 25,
                          callback: function(value) {
                            return  value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’")
                      }
                      }
                      }],
                      xAxes: [{
                      //barThickness: 25,  // number (pixels) or 'flex'
                      //maxBarThickness: 30 // number (pixels) 
                  }]
                  }  
        },
        chartOptions: {
          tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    return value.toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }],
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                            return  value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’")
                      }
              }
            }],
          }
        },
      }
    },
    created () {
      this.getList(this.apiPrefix, this.projectApiUrl)
        .then(resp => {
          this.projects = resp.data
          this.projectsFiltered = this.projects

          if (this.projects.length) {
            if (!this.projectId) {
              this.projectConsolidation(this.projects[0])
              this.currentProjectIndex = 0;
            } else {
              const index = this.findByProperty(this.projects, 'id', this.projectId)
              this.projectConsolidation(this.projects[index]);
              this.currentProjectIndex = index;
            }
          }
        })
        .catch(err => {
          console.log(err.response)
          this.$modal.show(OkModal, {
                    text: this.$t('message.oopsSomethingWentWrong'),
                    modalClass: this.modalClasses.okErrorClass
                  },
                  {
                    width: this.modalWidth(),
                    height: 'auto'
                  })

        })
    },
    methods: {
      refreshConsolidation(){
          this.projectConsolidation(this.currentProject);
      },
      projectConsolidation (project) {
        this.consolidationData = {};
        this.currentProject = project
        this.get(this.apiPrefix, this.projectApiUrl + 'consolidation/', '', project.id)
          .then(resp => {
            this.horizontalBarDataCollection = {}
            this.consolidationData = resp.data.data

            // add a filter_match property to consolidation data array
            this.consolidationData = Object.values(this.consolidationData).map(obj=> ({ 
            ...obj, 
            filter_matched: true,
            company_name_lower: obj.company_name.toLowerCase() 
            }))

            let dates = resp.data.rolling_forecast.dates
            let total_costs = resp.data.rolling_forecast.total_costs
            let colors = []


            // determine color of the bar as per it's date
            for(let i=0; i<dates.length; i++){
               let date = new Date(dates[i])
               if (date.getMonth() > new Date().getMonth() && date.getFullYear() >= new Date().getFullYear())
                  colors.push('red')
               else
                 colors.push('green')
            }

            

            this.currentProject['target_cost'] = this.sumAllCosts('target_cost')
            this.currentProject['static_budget'] = this.sumAllCosts('static_budget')

            // // add total additional budget to total static budget of the project
            // this.currentProject['static_budget'] += resp.data.additional_budget
             
            this.currentProject['dynamic_budget'] = this.sumAllCosts('dynamic_budget')
            this.currentProject['actual_costs'] = this.sumAllCosts('actual_costs')
            this.currentProject['total_invoiced'] = this.sumAllCosts('total_invoiced')


            // getting the rolling forecast bar by suming the array of rolling forecast per month by using reduce method
            this.currentProject['rolling_forecast'] = resp.data.rolling_forecast.total_costs.reduce((a, b) => a + b, 0)

            let data = [this.currentProject['target_cost'], this.currentProject['static_budget'] ,this.currentProject['actual_costs'], this.currentProject['dynamic_budget'], this.currentProject['rolling_forecast'], resp.data.additional_budget]
            
            
            this.stackedChartDataCollection = this.parseDataForStackedChart(data)

            this.horizontalBarDataCollection = this.parseDataForChartTotal(data, '#f87979', [this.$t('message.targetCost'), this.$t('message.staticBudget'),this.$t('message.dynamicBudget'),this.$t('message.actualCosts'), this.$t('message.rollingForecast')])
            this.barDataCollection=this.parseDataForChartTotal(total_costs, colors , dates)

            // consolidate data and assign them to global variables
            let completeData = this.consolidateData(resp)
            
            let backgroundColorsBars = this.getVerticalBarColors(resp.data.budget_history.dates)
            
            this.mixedChartDataCollection = this.parseDataForMixedChartTotal(completeData.mixedRollingForecastCosts, completeData.mixedTotalBudgetHistory ,this.$t('message.rollingForecast'), this.$t('message.budgetHistory'), completeData.mixedDates, backgroundColorsBars)

            // trigger a method in consolidation which will reloads mixed chart
            // and stacked bar chart
            // this.$refs.cons.triggerReloadMixedChart()
            // this.$refs.cons.triggerReloadStackedBar()
          })
          .catch(err => {
            console.log(err);
          this.$modal.show(OkModal, {
                    text: this.$t('message.oopsSomethingWentWrong'),
                    modalClass: this.modalClasses.okErrorClass
                  },
                  {
                    width: this.modalWidth(),
                    height: 'auto'
                  })

        })
      },
      // generalMixin method for returning the array of correct colors for vertical bars rolling forecast
      getVerticalBarColors(dates){
          return this.getBarColors(dates)
      },
      filterProjects () {
        let filter = this.projectsFilter.toLowerCase()

        this.projectsFiltered = this.projects.filter(project => {
          if (filter === '') {
            return true
          }

          return project.name.toLowerCase().startsWith(filter)
        })
      },
      getDynamicBudgetForProject () {
        let dynamicBudget = 0
        for (let k in this.consolidationData) {
          if (this.consolidationData.hasOwnProperty(k)) {
            dynamicBudget += this.consolidationData[k]['dynamic_budget']
          }
        }
        return dynamicBudget
      },
      getActualCostsForProject () {
        let actualCosts = 0
        for (let k in this.consolidationData) {
          if (this.consolidationData.hasOwnProperty(k)) {
            actualCosts += this.consolidationData[k]['actual_costs']
          }
        }
        return actualCosts
      },
      // sum all costs for the specified row
      sumAllCosts(typeOfCosts){
         let sumOfCosts = 0
         for (let k in this.consolidationData) {
          if (this.consolidationData.hasOwnProperty(k)) {
            sumOfCosts += this.consolidationData[k][typeOfCosts]
          }
        }
        return sumOfCosts
      },
      parseDataForStackedChart(data){
        
        const chartData = {
                    labels: [
                            this.$t('message.targetCost'), 
                            this.$t('message.staticBudget') , 
                            this.$t('message.actualCosts'),
                          //  this.$t('message.dynamicBudget') , 
                            this.$t('message.rollingForecast')],
                    datasets: [{
                    barThickness: 17,  
                    label: this.$t('message.data'),
                    backgroundColor: "rgba(236, 72, 78, 0.5)",
                    hoverBackgroundColor: "rgba(236, 72, 78, 1)",
                    data: [data[0], data[1], data[2], data[4]],
                    }, {
                    barThickness: 17,   
                    label: this.$t('message.additionalBudget'),
                    backgroundColor: "rgba(74, 167, 222, 0.5)",
                    hoverBackgroundColor: "rgba(74, 167, 222, 1)",
                    data: [0, data[5], 0, data[5], data[5]]
                    }]
                }

        return chartData
      },
      parseDataForChartTotal (data, color, labels) {
        return {
          labels: labels,
          datasets: [
            {
              barThickness: 12,
              backgroundColor: color,
              data: data
            }
          ]
        }
      },
      parseDataForMixedChartTotal(rollingForecast, budgetTotal, labelLine, labelBars, labels, backgroundColorsBars){
         return {
                    labels: labels,
                    datasets: [
                        { // one line graph
                          label: labelLine,
                          type: 'line',
                          data: rollingForecast,
                          backgroundColor: 'rgba(93,184,100,.5)'
                        },
                        { // bar graph
                          label: labelBars,
                          type: 'bar',
                          barThickness: 25,
                          data: budgetTotal,
                          backgroundColor: backgroundColorsBars
                        }
                    ]   
         }
      },
      // method for creating consolidated data from rolling forecast and budgets
      consolidateData(resp){
        return this.consolidate(resp)
      },
      setCurrentIndex(index) {
        this.currentProjectIndex = index;
        //console.log(this.currentProjectIndex);
      }
    }
  }
</script>

<style scoped>
    td, th {
        padding: 3px 9px;
    }

    .list-project-wrapper {
        max-height: 850px;
        overflow-y: auto;
    }

    .activeProject{
        color: #0b93d5;
    }
</style>